import { useState } from "react";
import painpro from "../assets/photos/PainProLogo.png";
import cedar from "../assets/photos/CedarLogo.png";
import lifeInt from "../assets/photos/LifeIntegrativeLogo.png";
import "../App.css";

const offices = [
  {
    id: "painpro",
    logo: painpro,
    bookingUrl: "https://painpro.janeapp.com/locations/burnaby-metrotown/book#/staff_member/702",
    mapsUrl: "https://maps.app.goo.gl/htRkg9pyDcB6oECo7",
    address: "Burnaby Metrotown",
    detail: "4710 Kingsway Suite 2148, Burnaby, BC V5H 4J5",
    days: "Thursday",
  },
  {
    id: "cedar",
    logo: cedar,
    bookingUrl: "https://cedarhealth.janeapp.com/?hl=en-CA&gei=B7m3Z4iCAfyJ0PEPuraIgAc#/staff_member/65",
    mapsUrl: "https://maps.app.goo.gl/b4jBE5z1nMtH4FLR8",
    address: "Cedar Health",
    detail: "Burnaby",
    days: "Mon · Wed · Fri",
  },
  {
    id: "life",
    logo: lifeInt,
    bookingUrl: "https://lifechiro.janeapp.com/#/staff_member/48",
    mapsUrl: "https://maps.app.goo.gl/x7DCfE2GbXRGqmKM7",
    address: "Life Integrative",
    detail: "B4168 Dunbar Street, Vancouver, BC V6S 2E7",
    days: "Sat · Sun",
  },
];

const ContactForm = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("http://localhost:8080/contact/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
    if (response.ok) {
      setStatus("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } else {
      setStatus("There was an error sending your message.");
    }
  };

  return (
    <div className="flex flex-col flex-1 page-fade-in">
      {/* Subtle top glow */}
      <div className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse 60% 40% at 50% 0%, rgba(200,150,31,0.04) 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-4xl mx-auto w-full px-6 py-12 flex flex-col gap-12">

        {/* ── Book an Appointment ── */}
        <section>
          <div className="flex items-center gap-4 mb-8">
            <span className="section-label">Locations</span>
            <div className="gold-divider flex-1" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {offices.map((office) => (
              <div
                key={office.id}
                className="glass-card rounded-2xl p-5 flex flex-col gap-4 transition-all duration-200"
                style={{ borderColor: "rgba(255,255,255,0.07)" }}
              >
                {/* Logo */}
                <a
                  href={office.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center h-14"
                >
                  <img
                    src={office.logo}
                    alt={office.id}
                    className="max-h-full max-w-full object-contain opacity-80 hover:opacity-100 transition-opacity"
                  />
                </a>

                <div className="gold-divider" />

                {/* Address */}
                <div>
                  <p className="text-white/80 text-sm font-medium">{office.address}</p>
                  <a
                    href={office.mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-white/40 hover:text-white/70 transition-colors mt-0.5 block leading-snug"
                  >
                    {office.detail}
                  </a>
                </div>

                {/* Days */}
                <span
                  className="self-start text-xs font-medium px-2.5 py-1 rounded-full"
                  style={{
                    background: "rgba(200,150,31,0.1)",
                    border: "1px solid rgba(200,150,31,0.22)",
                    color: "#c8961f",
                  }}
                >
                  {office.days}
                </span>

                {/* Book */}
                <a
                  href={office.bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto text-center btn-gold rounded-lg py-2 text-xs"
                >
                  Book Here →
                </a>
              </div>
            ))}
          </div>
        </section>

        {/* ── Contact Form ── */}
        <section>
          <div className="flex items-center gap-4 mb-8">
            <span className="section-label">Contact</span>
            <div className="gold-divider flex-1" />
          </div>

          <div
            className="glass-card p-6 md:p-8 rounded-2xl max-w-lg mx-auto"
            style={{ borderColor: "rgba(255,255,255,0.07)" }}
          >
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  className="input-dark flex-1"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  value={formData.email}
                  onChange={handleChange}
                  className="input-dark flex-1"
                  required
                />
              </div>

              <textarea
                name="message"
                placeholder="Type your message here..."
                value={formData.message}
                onChange={handleChange}
                className="input-dark resize-none"
                rows={4}
                required
              />

              <button type="submit" className="btn-gold w-full py-3 rounded-xl text-sm tracking-wide">
                Send Message
              </button>

              {status && (
                <p className={`text-center text-xs font-medium ${status.includes("error") ? "text-red-400" : "text-[#c8961f]"}`}>
                  {status}
                </p>
              )}
            </form>
          </div>
        </section>

      </div>
    </div>
  );
};

export default ContactForm;
